/**
 * The type of the action which signals that E2EE needs to be enabled / disabled.
 *
 * {
 *     type: TOGGLE_E2EE
 * }
 */
export const TOGGLE_E2EE = 'TOGGLE_E2EE';
/**
 * The type of the action which signals to set new value E2EE maxMode.
 *
 * {
 *     type: SET_MAX_MODE
 * }
 */
export const SET_MAX_MODE = 'SET_MAX_MODE';
/**
 * The type of the action which records who may enable AuthKey E2EE in this room.
 *
 * {
 *     type: SET_E2EE_ROOM_OWNER,
 *     ownerId: string | undefined
 * }
 */
export const SET_E2EE_ROOM_OWNER = 'SET_E2EE_ROOM_OWNER';
/**
 * The type of the action which records that E2EE should be enabled once AuthKey credentials are complete.
 *
 * {
 *     type: SET_E2EE_ENABLE_ON_CREDENTIAL_READY,
 *     enabled: boolean
 * }
 */
export const SET_E2EE_ENABLE_ON_CREDENTIAL_READY = 'SET_E2EE_ENABLE_ON_CREDENTIAL_READY';
/**
 * The type of the action which signals to set media encryption key for e2ee.
 *
 * {
 *     type: SET_MEDIA_ENCRYPTION_KEY
 * }
 */
export const SET_MEDIA_ENCRYPTION_KEY = 'SET_MEDIA_ENCRYPTION_KEY';
export const START_VERIFICATION = 'START_VERIFICATION';
export const PARTICIPANT_VERIFIED = 'PARTICIPANT_VERIFIED';
export const AUTHKEY_START_AKE = 'AUTHKEY_START_AKE';
export const AUTHKEY_AKE_RESPONSE = 'AUTHKEY_AKE_RESPONSE';
export const AUTHKEY_AKE_FINAL = 'AUTHKEY_AKE_FINAL';
export const AUTHKEY_AKE_FINISH = 'AUTHKEY_AKE_FINISH';
